import { AnyAsset, Inventario } from 'src/drheranca/types';
import {
  getAnyAssetPatrimonioValue,
  getAnyAssetValueForPurpose,
} from 'src/drheranca/services';

export type AssetValuationPurpose = 'DATA_OBITO' | 'DATA_ESCRITURA' | 'DATA_PARTILHA';

export function getAssetDisplayValue(asset: Record<string, unknown>): number {
  if (!asset) return 0;
  return getAnyAssetPatrimonioValue(asset as unknown as AnyAsset);
}

export function getAssetValueByPurpose(
  asset: Record<string, unknown>,
  purpose: AssetValuationPurpose,
): number {
  if (!asset) return 0;
  return getAnyAssetValueForPurpose(asset as unknown as AnyAsset, purpose);
}

export function getInventarioAssets(
  inventario: Inventario,
  key: keyof Inventario,
): Record<string, unknown>[] {
  return (
    ((inventario as unknown as Record<string, unknown>)[key] as
      | Record<string, unknown>[]
      | undefined) || []
  );
}
